import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-expandable-dropdown',
  templateUrl: './expandable-dropdown.component.html',
  styleUrls: ['./expandable-dropdown.component.scss'],
})
export class ExpandableDropdownComponent {
  @Input() title = 'Section';
  @Input() iconClass: string;
  @Input() options: unknown[];
  @Input() labelKey: string;
  @Input() sectionFormControl: FormControl;
  @Input() defaultOption: unknown;
  @Input() isExpandedByDefault = true;
  @Input() isExpandable = true;
}
